import translate from '~/zf/frontend/common/localization/translate';
import ComponentTypeIds from '../../../../../portlet/viiu/alarms/const/ComponentType.js';
import AlarmType from '../../../../../portlet/viiu/alarms/const/AlarmType';
function getComponentList() {
    return {
        [ComponentTypeIds.INVERTER]: {
            id: ComponentTypeIds.INVERTER,
            label: translate('common.INVERTER'),
        },
        [ComponentTypeIds.SYSTEM]: {
            id: ComponentTypeIds.SYSTEM,
            label: translate('common.TX_PLANT'),
        },
        [ComponentTypeIds.STRINGBOX]: {
            id: ComponentTypeIds.STRINGBOX,
            label: translate('common.STRING_COMBINER'),
        },
        [ComponentTypeIds.INVERTER]: {
            id: ComponentTypeIds.INVERTER,
            label: translate('common.INVERTER'),
        },
        [ComponentTypeIds.DATALOGGER]: {
            id: ComponentTypeIds.DATALOGGER,
            label: translate('common.DATALOGGER'),
        },
        [ComponentTypeIds.METER]: {
            id: ComponentTypeIds.METER,
            label: translate('common.METER'),
        },
        [ComponentTypeIds.PPC]: {
            id: ComponentTypeIds.PPC,
            label: translate('common.PPC'),
        },
        [ComponentTypeIds.STATUS]: {
            id: ComponentTypeIds.STATUS,
            label: translate('common.STATUS'),
        },
        [ComponentTypeIds.BATTERY]: {
            id: ComponentTypeIds.BATTERY,
            label: translate('common.BATTERY'),
        },
        [ComponentTypeIds.SENSOR]: {
            id: ComponentTypeIds.SENSOR,
            label: translate('common.SENSOR'),
        },
        [ComponentTypeIds.TRACKER]: {
            id: ComponentTypeIds.TRACKER,
            label: translate('common.TRACKER'),
        },
        [ComponentTypeIds.GENSET]: {
            id: ComponentTypeIds.GENSET,
            label: translate('common.GENSET'),
        },
    };
}
function getComponentFilterOptions() {
    const componentType = getComponentList();
    return {
        [AlarmType.TOTAL_OUTAGE]: [
            componentType[ComponentTypeIds.INVERTER],
            componentType[ComponentTypeIds.SYSTEM],
            componentType[ComponentTypeIds.STRINGBOX],
        ],
        [AlarmType.MISPRODUCTION]: [
            componentType[ComponentTypeIds.INVERTER],
            componentType[ComponentTypeIds.SYSTEM],
        ],
        [AlarmType.COMMUNICATION_LOSS]: [
            componentType[ComponentTypeIds.SYSTEM],
            componentType[ComponentTypeIds.DATALOGGER],
        ],
        [AlarmType.DATA_OUTAGE]: [
            componentType[ComponentTypeIds.INVERTER],
            componentType[ComponentTypeIds.SYSTEM],
            componentType[ComponentTypeIds.STRINGBOX],
            componentType[ComponentTypeIds.METER],
            componentType[ComponentTypeIds.PPC],
            componentType[ComponentTypeIds.STATUS],
            componentType[ComponentTypeIds.BATTERY],
            componentType[ComponentTypeIds.SENSOR],
            componentType[ComponentTypeIds.TRACKER],
        ],
        [AlarmType.USER_DEFINED]: [
            componentType[ComponentTypeIds.INVERTER],
            componentType[ComponentTypeIds.SYSTEM],
            componentType[ComponentTypeIds.STRINGBOX],
            componentType[ComponentTypeIds.METER],
            componentType[ComponentTypeIds.PPC],
            componentType[ComponentTypeIds.STATUS],
            componentType[ComponentTypeIds.BATTERY],
            componentType[ComponentTypeIds.SENSOR],
            componentType[ComponentTypeIds.TRACKER],
        ],
        [AlarmType.SENSOR_OUTAGE]: [
            componentType[ComponentTypeIds.SENSOR],
        ],
        [AlarmType.STRING_OUTAGE]: [
            componentType[ComponentTypeIds.INVERTER],
            componentType[ComponentTypeIds.STRINGBOX],
        ],
        [AlarmType.BATTERY_CHARGE_LEVEL]: [
            componentType[ComponentTypeIds.BATTERY],
        ],
        [AlarmType.TRACKER_DEVIATION]: [
            componentType[ComponentTypeIds.TRACKER],
        ],
    };
}
const ComponentTypesService = {
    getComponentFilterOptions,
    getComponentList,
};
export default ComponentTypesService;
